import type { PartnerBadge } from '@shopexperts/shared';
import type { ServiceCategory } from '../composables/useCategories';

/**
 * Mirrors of the API's `toPublicReference()` shapes so the editor preview can
 * feed sections the exact same metafield values a published page receives.
 */

export function badgeToPublicReference(badge: PartnerBadge): Record<string, unknown> {
  return {
    id: badge.id,
    name: badge.name,
    slug: badge.slug,
    status: badge.status,
    tag: badge.tag ?? null,
    expert_count: badge.expert_count ?? 0,
    icon: badge.icon
      ? { id: badge.icon.id, url: badge.icon.cdn_url || badge.icon.url }
      : null,
  };
}

export function categoryToPublicReference(category: ServiceCategory): Record<string, unknown> {
  return {
    id: category.id,
    name: category.name,
    slug: category.slug,
    type: 'category',
  };
}

export function subcategoryToPublicReference(
  subcategory: ServiceCategory,
  parentCategory?: ServiceCategory,
): Record<string, unknown> {
  return {
    id: subcategory.id,
    name: subcategory.name,
    slug: subcategory.slug,
    type: 'subcategory',
    category_id: parentCategory?.id ?? null,
    category: parentCategory ? categoryToPublicReference(parentCategory) : null,
  };
}
